import { Tooltip, Typography } from "antd";
const { Text } = Typography;
const RenderNameWithEllipsis = ({ content, maxWidth = "250px" }) => {
    return (
        <Tooltip placement="top" title={content}>
            <Text ellipsis style={{ maxWidth: maxWidth, minWidth: "50%" }}>
                {content}
            </Text>
        </Tooltip>
    );
};

export default RenderNameWithEllipsis;
